// extracted by css-extract-rspack-plugin
export default {"moderationNotesContainer":"moderationNotesContainer__nOpLd","moderationHeader":"moderationHeader__NPZ4f","moderationText":"moderationText__Kv7Hu"};